// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] + "." + {"265":"b33cfffa","297":"fc6e11e2","643":"a6dc752d"}[chunkId] + ".chunk.js";
};